import { render, staticRenderFns } from "./ia.vue?vue&type=template&id=db5ceb9c&scoped=true&"
import script from "./ia.vue?vue&type=script&lang=js&"
export * from "./ia.vue?vue&type=script&lang=js&"
import style0 from "./ia.vue?vue&type=style&index=0&id=db5ceb9c&prod&scoped=true&lang=css&"
import style1 from "./ia.vue?vue&type=style&index=1&id=db5ceb9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5ceb9c",
  null
  
)

export default component.exports